module.exports = __webpack_public_path__ + "img/ic_up.4f2364bb.svg";